
import React from 'react';
import { Cat } from 'lucide-react';

export const FormHeader = () => {
  return (
    <div className="flex items-center justify-end">
      <h2 className="text-2xl font-semibold flex items-center gap-2">
        <span dir="rtl" className="text-right">משימה חדשה</span>
        <Cat className="h-6 w-6 text-cat-primary" />
      </h2>
    </div>
  );
};
